"use client";

import { useEffect, useRef } from 'react';

export const NewRelicAgent = () => {
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        if (typeof window !== 'undefined') {
            const appId = process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID;
            const browserKey = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_KEY;
            const accountId = process.env.NEXT_PUBLIC_NEW_RELIC_ACCOUNT_ID;
            const agentId = process.env.NEXT_PUBLIC_NEW_RELIC_AGENT_ID;
            const trustKey = process.env.NEXT_PUBLIC_NEW_RELIC_TRUST_KEY;

            if (!appId || !browserKey || !accountId || !agentId || !trustKey) {
                return;
            }

            import('@newrelic/browser-agent/loaders/browser-agent').then(({ BrowserAgent }) => {
                const options = {
                    info: {
                        applicationID: appId,
                        beacon: "bam.nr-data.net",
                        errorBeacon: "bam.nr-data.net",
                        licenseKey: browserKey,
                        sa: 1
                    },
                    init: {
                        ajax: { deny_list: ["bam.nr-data.net"] },
                        browser_consent_mode: { enabled: false },
                        distributed_tracing: { enabled: true },
                        performance: { capture_detail: false, capture_marks: false, capture_measures: true },
                        privacy: { cookies_enabled: true }
                    },
                    loader_config: {
                        accountID: accountId,
                        agentID: agentId,
                        applicationID: appId,
                        licenseKey: browserKey,
                        trustKey: trustKey
                    }
                };

                try {
                    new BrowserAgent(options);
                } catch (e) {
                    console.error('Failed to initialize New Relic Browser Agent:', e);
                }
            });
        }
    }, []);

    return null;
};
